const scenarios = [
  {
    icon: "ri-film-line",
    tint: "bg-primary-100 text-primary-700",
    title: "追剧存档",
    text: "看过的剧集去水印存进合集，换设备也能随时回看，不怕下架。",
    tag: "去水印",
  },
  {
    icon: "ri-live-line",
    tint: "bg-accent-100 text-accent-700",
    title: "直播补课",
    text: "赶不上直播就开录屏，直播结束回放照看，弹幕高能也能补上。",
    tag: "录屏",
  },
  {
    icon: "ri-chat-smile-3-line",
    tint: "bg-secondary-100 text-secondary-800",
    title: "弹幕氛围组",
    text: "同屏聚合多端弹幕，名场面一起刷屏，看热闹绝不冷场。",
    tag: "弹幕聚合",
  },
  {
    icon: "ri-graduation-cap-line",
    tint: "bg-accent-100 text-accent-700",
    title: "网课复盘",
    text: "倍速跳过废话、片段循环啃重点，录下板书回看，效率拉满。",
    tag: "倍速",
  },
  {
    icon: "ri-scissors-2-line",
    tint: "bg-primary-100 text-primary-700",
    title: "二创素材",
    text: "原画去水印存干净素材，卡点循环截片段，剪起来一次到位。",
    tag: "解析",
  },
  {
    icon: "ri-bookmark-3-line",
    tint: "bg-secondary-100 text-secondary-800",
    title: "精品收藏",
    text: "解析后把干货转成可播链接统一归档，收藏夹从此只进不出。",
    tag: "聚合",
  },
];

export default function ScenarioSection() {
  return (
    <section id="scene" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-cup-line" />
              妙用场景
            </span>
            <h2 className="mt-3 text-2xl font-black text-foreground-950 md:text-3xl">
              这套玩法放在哪些地方最顺手
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              去水印、解析、倍速、录屏、弹幕、聚合不是各用各的，搭在一起才吃得爽。
            </p>
          </div>
          <span className="hidden whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900 lg:inline-block">
            左右滑动查看更多场景
          </span>
        </div>

        <div className="mt-8 flex snap-x gap-3 overflow-x-auto pb-2 no-scrollbar md:grid md:grid-cols-3 md:overflow-visible">
          {scenarios.map((s) => (
            <article
              key={s.title}
              className="flex w-64 shrink-0 snap-start flex-col rounded-2xl border border-background-200 bg-background-100 p-4 transition-transform hover:-translate-y-1 md:w-auto md:p-5"
            >
              <div className="flex items-center justify-between">
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-xl ${s.tint}`}
                >
                  <i className={`${s.icon} text-lg`} />
                </span>
                <span className="whitespace-nowrap rounded-full bg-background-50 px-2.5 py-0.5 text-[11px] text-foreground-500 ring-1 ring-background-200">
                  {s.tag}
                </span>
              </div>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{s.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}